import '../css/tailwind.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueToasted from '@hoppscotch/vue-toasted';
import httpPlugin from '@kate/plugins/http';
import loggerPlugin from '@kate/plugins/logger';
import App from './app.vue';
import router from './router';
import useGlobalStore from '@stores/global';
import getEnvironmentConfig from './get-environment-config';
import KToast from '@plugins/k-toast';

const { applicantPortalApi } = getEnvironmentConfig();
const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(loggerPlugin, {
  router,
  getStateInfo: () => ({
    appName: 'applicant_portal',
    userId: useGlobalStore(pinia).userId,
  }),
});
app.use(httpPlugin, {
  axios: {
    baseURL: applicantPortalApi || '/',
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    },
  },
});
app.use(VueToasted, { iconPack: 'fontawesome', router });
app.use(KToast);
// Last, as installing it starts the first navigation, whose session guard uses the plugins above.
app.use(router);

// Mounted straight away, so the app's loader shows while the first navigation loads the session.
app.mount('#app');
